module.exports = __webpack_public_path__ + "img/empty.a3e73287.svg";